import { Breadcrumbs, Typography } from "@mui/material";
import React from "react";
import aboutimg from "../../../assets/img/img-about.png";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import { Link } from "react-router-dom";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import siderbg from "../../../assets/img/bg-about.png";
import rings from "../../../assets/img/item-1.png";
import logo from "../../../assets/img/logo-siyora.png";
import about1 from "../../../assets/img/about-why1.jpeg";
import about2 from "../../../assets/img/about-why2.jpeg";
import about3 from "../../../assets/img/about-1-6.svg";
import ourmission from "../../../assets/img/our-mission.png";
import Review from "../../../components/front/Review";
import HTMLContent from "../../../components/HTMLContent";
import { imgBaseURL } from "../../../utility/Utility";

const About = ({ pageData }) => {
  return (
    <>
      <div
        className="innabout-section"
        style={{ backgroundImage: `url(${siderbg})` }}
      >
        <div className="container">
          <Breadcrumbs
            aria-label="breadcrumb"
            className="breacrumb-custom py-md-3 py-2"
            separator={<NavigateNextIcon fontSize="small" />}
          >
            <Link underline="hover" to="/"> Home </Link>
            <Typography>{pageData?.title}</Typography>
          </Breadcrumbs>
          <h1>{pageData?.title}</h1>
        </div>
      </div>
      {/* <div className="about-us-content">
        <div className="container">
          <div className="row term-card align-items-center mb-4">
            <HTMLContent data={pageData?.content} />
          </div>
        </div>
      </div> */}
      <div className="about-us-content">
        <div className="container">
          <div className="row  mb-4 align-items-center justify-content-between">
            <div className="col-md-4 order-md-1 order-2" >
              <div className="brand_intro_image">

                <img src={imgBaseURL() + pageData?.image} alt="" />
                <div className="brand-box">
                  <img src={rings} alt="" />
                </div>
              </div>
            </div>
            <div className="col-md-7 mb-md-0 mb-2 order-md-2 order-1">
              <HTMLContent data={pageData?.content} />
            </div>
          </div>

        </div>
      </div>
      <section class="about_experince_missin">
        <div class="container">
          <div class="row align-items-center justify-content-between">
            <div class="col-md-6 mb-md-0 mb-4 ">
              <div class="expert_cnt">
                <h2>Our Mission</h2>
                <HTMLContent data={pageData?.content_2} />
              </div>
            </div>
            <div class="col-md-5 mb-md-0 mb-4">
              <div class="images_box">
                <div class="big_one_img">
                  <img src={ourmission} alt="img" width="100%" height="auto" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div className="why_choose_siyora">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-6 order-md-1 order-2 ">
              <div className="img-box5 w-100">
                <div className="img1">
                  <img decoding="async" src={about1} alt="about 1 3" /></div>
                <div className="img2"><img src={about2} alt="about 1 4" /></div>
                <div className="img3"><img src={about3} alt="about 1 6" /></div>
              </div>
            </div>
            <div className="col-md-6 order-md-2 order-1">
              <div className="why_choose_inner">
                <h2>
                  Why Siyora?
                </h2>
                <p>
                  Because we believe jewellery should be more than just an accessory—it should feel like you. From delicate essentials to bold statements, our collections are designed to complement your style and grow with your journey.
                </p>
                <p><strong>
                  Siyora Jewels—</strong> <em>
                    Where elegance meets everyday.
                  </em>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="mb-5">
        <Review />
      </div>
    </>
  );
};

export default About;